import LoadingBox from 'components/Common/Loading/LoadingBox'
import LabelLoadingBox from 'LuxKit/Label/LabelLoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import type { HTMLAttributes } from 'react'
import { memo } from 'react'
import styled from 'styled-components'
import clsx from 'clsx'

const Container = styled.div`
  display: grid;
  grid-template:
    'media' ${rem(200)}
    'content' 1fr / 1fr;
  gap: ${rem(16)};
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: ${rem(320)};
  }

  &.size-medium {
    ${mediaQueryUp.desktop} {
      width: ${rem(512)};
    }
  }

`

const ImageLoadingBox = styled(LoadingBox)`
  height: ${rem(200)};
`

const ButtonLoadingBox = styled(LoadingBox)`
  height: ${rem(40)};
`

interface Props extends Pick<HTMLAttributes<HTMLDivElement>, 'className' | 'onTransitionEnd'> {
  size: 'small' | 'medium'
}

function CarouselLockedCardLoadingSkeleton(props: Props) {
  const { size, className, onTransitionEnd } = props

  return <Container className={clsx(className, `size-${size}`)} onTransitionEnd={onTransitionEnd}>
    <ImageLoadingBox />
    <Group direction="vertical" verticalAlign="space-between" gap={16}>
      <Group direction="vertical" gap={8}>
        <LabelLoadingBox width={220} />
        <TextLoadingBox typography="heading5" width="100%" lines={2} />
      </Group>
      <ButtonLoadingBox />
    </Group>
  </Container>
}

export default memo(CarouselLockedCardLoadingSkeleton)
